import React, { useContext } from 'react'
import { Navigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { AuthContext } from '../../libs/contexts/authContext'

function AuthGuard(props) {
  const location = useLocation()
  const { affiliateCode } = useContext(AuthContext)
  const { search } = location
  if (!props.isAuthenticated) {
    return <Navigate to={`/login?affiliateCode=${affiliateCode}`} />
  }
  return <>{props.children}</>
}

export default AuthGuard
